export interface ContactRole {
  privilege: string;
  name: string;
  id: string;
  contactId: string;
  privilegeId: number;
  roleId: string | null;
}
